import { registerPlugin } from '@capacitor/core';

const AudioSession = registerPlugin('AudioSession');

const InterruptionTypes = {
  BEGAN: 'began',
  ENDED: 'ended',
};

export { AudioSession, InterruptionTypes };
